export default __webpack_public_path__ + "static/media/laptop-myresource.5fa6c9e3.jpg";